/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectFeFleetMOType
 */
export interface MonitoredObjectFeFleetMOType {
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectFeFleetMOType
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetMOType
     */
    name?: string | null;
}

export function MonitoredObjectFeFleetMOTypeFromJSON(json: any): MonitoredObjectFeFleetMOType {
    return MonitoredObjectFeFleetMOTypeFromJSONTyped(json, false);
}

export function MonitoredObjectFeFleetMOTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectFeFleetMOType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MonitoredObjectFeFleetMOTypeToJSON(value?: MonitoredObjectFeFleetMOType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


